import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { LANGUAGE_NAMES, DEFAULT_LANGUAGE } from '../../../../service/constants';

const TitleDescriptionSection = ({ 
    name, 
    detail, 
    onNameChange, 
    onDetailChange, 
    nameError, 
    detailError,
    lang = DEFAULT_LANGUAGE
}) => {
    const languageLabel = LANGUAGE_NAMES[lang] || "";
    const languageSuffix = ` (${languageLabel})`;
    
    return (
        <>
            <div className="form-group">
                <label>Título{languageSuffix}</label>
                <input 
                    name="name" 
                    onChange={onNameChange} 
                    value={name || ""} 
                    type="text" 
                    className="form-control" 
                />
                <Alert show={!!nameError} className="mt-2" variant="danger">{nameError}</Alert>
            </div>
            <div className="form-group">
                <label>Descripción{languageSuffix}</label>
                <textarea 
                    name="detail" 
                    onChange={onDetailChange} 
                    value={detail || ""} 
                    className="form-control" 
                    rows="3" 
                />
                <Alert show={!!detailError} className="mt-2" variant="danger">{detailError}</Alert>
            </div>
        </>
    );
};

export default TitleDescriptionSection;
